<template>
  <div class="fs-nav" v-if="selected">
    <a v-if="!topMenuConfig.lockFlip" @click.prevent="flip" :alt="$t(`misc.flip`)" class="mi">flip</a>
    <a v-if="!topMenuConfig.lockFlip" @click.prevent="flop" :alt="$t(`misc.flop`)" class="mi flop">flip</a>
    <a v-if="!topMenuConfig.lockRotation" @click.prevent="rotateLeft" :alt="$t(`misc.rotate_left`)" class="mi">rotate_left</a>
    <a v-if="!topMenuConfig.lockRotation" @click.prevent="rotateRight" :alt="$t(`misc.rotate_right`)" class="mi">rotate_right</a>
    <span class="fs-nav-separator"></span>
    <a v-if="enabledLayersNav()" :class="{ 'fs-disabled': isLastLayer() }" @click.prevent="changeLayerOrder('SEND_UP')" :alt="$t(`misc.move_to_front`)" class="mi">flip_to_front</a>
    <a v-if="enabledLayersNav()" :class="{ 'fs-disabled': isFirstLayer() }" @click.prevent="changeLayerOrder('SEND_DOWN')" :alt="$t(`misc.move_to_back`)" class="mi">flip_to_back</a>
    <span v-if="enabledLayersNav()" class="fs-nav-separator"></span>
    <a v-if="topMenuConfig.remove" @click.prevent="remove" class="mi">delete</a>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Inject, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { CANVAS_EVENTS, FsCanvas, LAYER_POSITION_ACTION, AbstractLayer } from '@filestack/canvas-sdk';

@Component
class TopLayerMenu extends Vue {
  @Inject('canvas')
  public canvas: FsCanvas;

  @Getter('config')
  public config: any;

  private selected: AbstractLayer = null;

  get topMenuConfig() {
    // @ts-ignore @todo
    return this.config('editor.topMenu');
  }

  public selectionChangedCallback(data: AbstractLayer) {
    this.selected = data;
  }

  public mounted() {
    // @ts-ignore
    this.selected = this.$route.params.selected;
    this.canvas.on(CANVAS_EVENTS.SELECTION_CHANGED, this.selectionChangedCallback);
  }

  public destroyed() {
    this.canvas.off(CANVAS_EVENTS.SELECTION_CHANGED, this.selectionChangedCallback);
  }

  public isFirstLayer(): boolean {
    if (this.selected) {
      return this.canvas.layer.isFirstLayer(this.selected);
    }

    return true;
  }

  public isLastLayer(): boolean {
    if (this.selected) {
      return this.canvas.layer.isLastLayer(this.selected);
    }

    return true;
  }


  public enabledLayersNav(): boolean {
    if (!this.topMenuConfig.layers) {
      return false;
    }

    if (this.selected) {
      return !this.canvas.layer.isOnlyLayer;
    }

    return true;
  }

  public flip() {
    if (this.selected) {
      this.selected.flip();
      this.canvas.saveState('layerFlipX');
    }
  }

  public flop() {
    if (this.selected) {
      this.selected.flop();
      this.canvas.saveState('layerFlipY');
    }
  }

  public rotateRight() {
    if (this.selected) {
      this.selected.rotateRight();
      this.canvas.saveState('layerRotateRight');
    }
  }

  public rotateLeft() {
    if (this.selected) {
      this.selected.rotateLeft();
      this.canvas.saveState('layerRotateLeft');
    }
  }

  public changeLayerOrder(type: LAYER_POSITION_ACTION) {
    if (this.selected) {
      this.canvas.layer.changeLayerOrder(this.selected, type);
      this.canvas.saveState('layerChangeLayerOrder');
    }
  }

  public remove() {
    if (!this.selected) {
      return;
    }

    this.canvas.layer.remove(this.selected);
    this.canvas.saveState('layerRemove');
    this.$router.push('/');
  }
}

export default TopLayerMenu;
</script>
